import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col /* Alert */ } from "react-bootstrap";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import ItemService from "../../../../services/customer_appCommonService";

const BulkUploadFilter = (props) => {
  const { getfiltereddata, onSubmit } = props; // Access the filtered data passed as a prop
  const [getCompanyCode, setCompanyCode] = useState([]);
  const [getCustomer, setCustomer] = useState([]);

  const months = [
    { id: 1, name: "January", code: 1 },
    { id: 2, name: "February", code: 2 },
    { id: 3, name: "March", code: 3 },
    { id: 4, name: "April", code: 4 },
    { id: 5, name: "May", code: 5 },
    { id: 6, name: "June", code: 6 },
    { id: 7, name: "July", code: 7 },
    { id: 8, name: "August", code: 8 },
    { id: 9, name: "September", code: 9 },
    { id: 10, name: "October", code: 10 },
    { id: 11, name: "November", code: 11 }, // ✅ Corrected
    { id: 12, name: "December", code: 12 }, // ✅ Corrected
  ];

  const years = [
    { id: 2025, name: "2025", code: 2025 },
    { id: 2024, name: "2024", code: 2024 },
    { id: 2023, name: "2023", code: 2023 },
    { id: 2022, name: "2022", code: 2022 },
    { id: 2021, name: "2021", code: 2021 },
    { id: 2020, name: "2020", code: 2020 },
    { id: 2019, name: "2019", code: 2019 },
    { id: 2018, name: "2018", code: 2018 },
    { id: 2017, name: "2017", code: 2017 },
    { id: 2016, name: "2016", code: 2016 },
  ];

  const [getFilterData, setFilterData] = useState();
  const [getDropdownData, setDropdownData] = useState("");

  const [getcustomerContactPerson, setcustomerContactPerson] = useState([
    {
      id: 1,
      action: "",
      value: "",
    },
  ]);

  const companyCodeMap = {
    SSA: "SRI SRINIVASA ASSOCIATES",
    SVT: "SRI VENKATESHWARA TRADERS",
    AKE: "AKSHARA ENTERPRIES",
    DBC: "DHARANI BUILD CAPITALS",
    SSI: "SRI SAPTHAGIRI INFRA",
    BRI: "BRINDAVAN INFRA",
    SVA: "SRI VENKATESWARA AGENCIES",
  };

  const reverseCompanyCodeMap = Object.entries(companyCodeMap).reduce(
    (acc, [code, name]) => {
      acc[name.trim()] = code;
      return acc;
    },
    {}
  );

  useEffect(() => {

    if (!getDropdownData || !getDropdownData.index) return;

    setcustomerContactPerson((prev) =>
      prev.map((doc) => {
        if (doc.id !== getDropdownData.index) return doc;

        // For actionCode or userId
        if (
          getDropdownData?.textCode === "actionCode" ||
          getDropdownData?.textCode === "userId"
        ) {
          return {
            ...doc,
            [getDropdownData.textField]: getDropdownData.name,
            [getDropdownData.textCode]: getDropdownData.id,
          };
        }

        if (
          getDropdownData?.textField === "month" ||
          getDropdownData?.textField === "years"
        ) {
          return {
            ...doc,
            [getDropdownData.textField]: getDropdownData.code,
          };
        }

        if (getDropdownData?.textCode === "companyCode") {
          customerDataDropdown(getDropdownData?.id);

          return {
            ...doc,
            //      [getDropdownData?.textField]: getDropdownData?.name,
            // [getDropdownData?.textCode]: getDropdownData?.id,
            [getDropdownData?.textField]: getDropdownData?.description,
          };
        }

        return doc;
      })
    );
  }, [getDropdownData]);
  const customerDataDropdown = async (code) => {
    let obj = {
      companyCode: code,
    };

    await ItemService.getCustomersByCompany(obj).then((item) => {
      if (item?.status === 200) {
        setCustomer(item?.data);
      } else {
        setCustomer([]);
        console.log(">> Error: Loading getCustomers");
      }
    });
  };

  const loadMasterData = async () => {
    let obj1 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading Company Code");
      }
    });
  };
  useEffect(() => {
    loadMasterData();
  }, []);
  const extractIds = () => {
    const filtered = getfiltereddata
      .filter((col) => col.id)
      .map((col) => ({ id: col.id, name: col.name }));
    setFilterData(filtered);
  };

  // Call once when needed, e.g., on mount
  useEffect(() => {
    extractIds();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCancel = () => {
    props.cancelAction();
  };

  const handleClearAll = () => {
    setcustomerContactPerson([
      {
        id: Date.now(),
        action: "",
        value: "",
      },
    ]);
  };

  const handleSubmit = () => {
    const filter = {};

    getcustomerContactPerson.forEach((doc) => {
      const action = doc.actionCode;

      // Date range filters
      if (action === "createdAt" || action === "generatedDate") {
        if (doc.fromDate || doc.toDate) {
          filter[action] = {};
          if (doc.fromDate) filter[action]["$gte"] = doc.fromDate;
          if (doc.toDate) filter[action]["$lte"] = doc.toDate;
        }

        // Range filters (numbers, strings)
      } else if (
        action === "documentNumber" ||
        action === "userId" ||
        action === "invoiceNr" ||
        action === "orderSchedulingNr" ||
        action === "loadingAdviceNr" ||
        action === "e_WayBillNo"
      ) {
        filter[action] = {
          $gte: doc.greaterThan,
          $lte: doc.lessThan,
        };

        // Exact match or mapped filters
      } else if (
        action === "companyCodeDesc" ||
        action === "companyCodeCode" ||
        action === "customerName" ||
        action === "organisationName" ||
        action === "createdByName" ||
        action === "materialDescription"
      ) {
        let value = doc.greaterThan || "";

        // Handle specific known fields if present
        if (action === "companyCodeCode") {
          const input = (doc.companyCode || value || "").trim();
          value = reverseCompanyCodeMap[input] || input;
        } else if (doc.customerName) {
          value = doc.customerName;
        } else if (doc.organisationName) {
          value = doc.organisationName;
        } else if (doc.materialDescription) {
          value = doc.materialDescription;
        } else if (doc.createdByName) {
          value = doc.createdByName;
        }

        if (value) {
          filter[action] = value;
        }

        // Month-Year filtering
      } else if (action === "month") {
        if (doc.month) filter["month"] = doc.month;
        if (doc.years) filter["year"] = doc.years;
      }
    });



    onSubmit(filter);
  };

  // console.log(">>getcustomerContactPerson", getcustomerContactPerson);
  /* ---------------------Customer Contact Person -------- */

  const deleteCustomerContactPerosn = (id) => {
    const updatedData1 = getcustomerContactPerson.filter(
      (doc) => doc.id !== id
    );
    setcustomerContactPerson(updatedData1);
  };
  const addCustomerCantactPerson = () => {
    const newDocument = {
      id: Date.now(),
      action: "",
      value: "",
    };
    setcustomerContactPerson((prevData) => [...prevData, newDocument]);
  };
  const handleChangeCustomerContacts = (id, fieldName, value) => {
    // Update state
    setcustomerContactPerson((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc
      )
    );
  };

  return (
    <div className="filterBox p-0 m-0 mb-2">
      {/* {error && <Alert variant="danger py-2">{error}</Alert>} */}
      <Form>
        <Form.Group as={Row} className="mb-3">
          <div className="d-flex-column justify-content-center">
            <Row className="pt-4 d-none d-lg-flex ">
              <Col xs={12} md={3} lg={3}>
                <p className="fs-6 fw-medium d-flex ms-4">Action</p>
              </Col>

              <Col xs={12} md={3} lg={3}>
                <p className="fs-6 fw-medium d-flex ms-4">Value</p>
              </Col>
            </Row>
            {getcustomerContactPerson.map((doc, index) => (
              <Row key={doc.id}>
                <Col xs={12}>
                  <hr className="mx-4 my-0 text-color-black" />
                </Col>
                <Col
                  xs={12}
                  md={3}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <ComboboxField
                    label=""
                    placeholder="Action"
                    data={getFilterData}
                    id="action"
                    iconClassName="dropdownIcon"
                    name="action"
                    code="actionCode"
                    description="actionDesc"
                    setValue={doc?.action}
                    getvalue={setDropdownData}
                    index={doc.id}
                    onChangeValue={handleChangeCustomerContacts}
                  />
                </Col>
                {(doc.actionCode === "documentNumber" ||
                  doc.actionCode === "userId" ||
                  doc.actionCode === "invoiceNr" ||
                  doc.actionCode === "orderSchedulingNr" ||
                  doc.actionCode === "loadingAdviceNr" ||
                  doc.actionCode === "e_WayBillNo") && (
                    <>
                      <Col
                        xs={12}
                        md={3}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox mt-1"
                          name="lessThan"
                          placeholder="Highest Nr"
                          value={doc.lessThan || ""}
                          onChange={(e) =>
                            handleChangeCustomerContacts(
                              doc.id,
                              "lessThan",
                              e.target.value
                            )
                          }
                        // error={
                        //   validation[
                        //     `${doc.id}_contactName`
                        //   ]
                        // }
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={3}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox mt-1"
                          name="value"
                          placeholder="Lowest Nr"
                          value={doc.greaterThan || ""}
                          onChange={(e) =>
                            handleChangeCustomerContacts(
                              doc.id,
                              "greaterThan",
                              e.target.value
                            )
                          }
                        // error={
                        //   validation[
                        //     `${doc.id}_contactName`
                        //   ]
                        // }
                        />
                      </Col>
                    </>
                  )}
                {(doc.actionCode === "materialDescription") && (
                  <>
                    <Col
                      xs={12}
                      md={3}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox mt-1"
                        name="textField"
                        placeholder="Text"
                        value={doc.greaterThan || ""}
                        onChange={(e) =>
                          handleChangeCustomerContacts(
                            doc.id,
                            "greaterThan",
                            e.target.value
                          )
                        }
                      // error={
                      //   validation[
                      //     `${doc.id}_contactName`
                      //   ]
                      // }
                      />
                    </Col>

                  </>
                )}

                {(doc.actionCode === "companyCodeDesc" || doc.actionCode === "createdByName" || doc.actionCode === "companyCodeCode") && (
                  <>
                    {/* <Col
                      xs={12}
                      md={3}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox mt-1"
                        name="textField"
                        placeholder="Text"
                        value={doc.greaterThan || ""}
                        onChange={(e) =>
                          handleChangeCustomerContacts(
                            doc.id,
                            "greaterThan",
                            e.target.value
                          )
                        }
                        // error={
                        //   validation[
                        //     `${doc.id}_contactName`
                        //   ]
                        // }
                      />
                    </Col> */}

                    <Col
                      xs={12}
                      md={3}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <ComboboxField
                        label=""
                        placeholder="Action"
                        data={getCompanyCode}
                        id="companyCode"
                        iconClassName="dropdownIcon"
                        name="companyCode"
                        code="companyCode"
                        description="companyCodeDesc"
                        setValue={doc?.companyCode}
                        getvalue={setDropdownData}
                        index={doc.id}
                        onChangeValue={handleChangeCustomerContacts}
                      />
                    </Col>
                  </>
                )}
                {(doc.actionCode === "customerName" || doc.actionCode === "organisationName") && (
                  <>
                    <Col
                      xs={12}
                      md={3}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <ComboboxField
                        label=""
                        placeholder="Action"
                        data={getCustomer}
                        id="customerName"
                        iconClassName="dropdownIcon"
                        name="customerName"
                        code="customerCode"
                        description="customerNameDesc"
                        setValue={doc?.customerName}
                        getvalue={setDropdownData}
                        index={doc.id}
                        onChangeValue={handleChangeCustomerContacts}
                      />
                    </Col>
                  </>
                )}
                {(doc.actionCode === "createdAt" ||
                  doc.actionCode === "generatedDate") && (
                    <>
                      <Col
                        xs={12}
                        md={3}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox mt-1"
                          name="fromDate"
                          placeholder="From Date"
                          value={doc.fromDate || ""}
                          type="date"
                          min={2023}
                          onChange={(e) =>
                            handleChangeCustomerContacts(
                              doc.id,
                              "fromDate",
                              e.target.value
                            )
                          }
                        // error={
                        //   validation[
                        //     `${doc.id}_contactName`
                        //   ]
                        // }
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={3}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox mt-1"
                          name="toDate"
                          placeholder="toDate"
                          value={doc.toDate || ""}
                          type="date"
                          min={2023}
                          onChange={(e) =>
                            handleChangeCustomerContacts(
                              doc.id,
                              "toDate",
                              e.target.value
                            )
                          }
                        // error={
                        //   validation[
                        //     `${doc.id}_contactName`
                        //   ]
                        // }
                        />
                      </Col>
                    </>
                  )}
                {doc.actionCode === "month" && (
                  <>
                    <Col
                      xs={12}
                      md={3}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <ComboboxField
                        label=""
                        placeholder="Action"
                        data={months}
                        id="month"
                        iconClassName="dropdownIcon"
                        name="month"
                        code="monthCode"
                        description="monthDesc"
                        setValue={doc?.month}
                        getvalue={setDropdownData}
                        index={doc.id}
                        onChangeValue={handleChangeCustomerContacts}
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={3}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <ComboboxField
                        label=""
                        placeholder="Action"
                        data={years}
                        id="years"
                        iconClassName="dropdownIcon"
                        name="years"
                        code="yearsCode"
                        description="yearsDesc"
                        setValue={doc?.years}
                        getvalue={setDropdownData}
                        index={doc.id}
                        onChangeValue={handleChangeCustomerContacts}
                      />
                    </Col>
                  </>
                )}

                <Col
                  xs={12}
                  md={3}
                  lg={3}
                  className="commTopButtonRightLeftPadding d-flex align-items-center"
                >
                  {index !== 0 && (
                    <Button
                      className="btnTable w-25"
                      variant="danger"
                      // onClick={handleAddField}
                      onClick={() => deleteCustomerContactPerosn(doc.id)}
                    >
                      -
                    </Button>
                  )}
                  <Button
                    className="btnTable w-25"
                    variant="primary"
                    // onClick={handleAddField}
                    onClick={() => addCustomerCantactPerson(doc.id)}
                  >
                    +
                  </Button>
                </Col>
                <Col
                  xs={12}
                  md={1}
                  lg={1}
                  className="commTopButtonRightLeftPadding d-flex align-items-center"
                ></Col>
              </Row>
            ))}
          </div>
          <Row>
            <Col sm={3} className="commTopButtonRightLeftPadding">
              <h6>&nbsp;</h6>
              <Button variant="primary" onClick={handleSubmit}>
                Search
              </Button>
              <Button variant="danger" onClick={handleClearAll}>
                Clear
              </Button>
              <Button variant="danger" onClick={handleCancel}>
                Cancel
              </Button>
            </Col>
          </Row>
        </Form.Group>
      </Form>
    </div>
  );
};

export default BulkUploadFilter;
